import { render, staticRenderFns } from "./ZoneUsageCodeDetail.vue?vue&type=template&id=5673deda&scoped=true"
import script from "./ZoneUsageCodeDetail.vue?vue&type=script&lang=js"
export * from "./ZoneUsageCodeDetail.vue?vue&type=script&lang=js"
import style0 from "./ZoneUsageCodeDetail.vue?vue&type=style&index=0&id=5673deda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5673deda",
  null
  
)

export default component.exports